import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import FamilyCoexistenceList from './table';
import { DeclarationCohabitationFormVM } from 'mutation/view-models/declaration-cohabitation';
import { noop } from 'shell/utils/noop';

interface FamilyCoexistenceProps {
  disabled?: boolean;
}

const AccordionFamilyCoexistenceListComponent = ({
  disabled,
}: FamilyCoexistenceProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<DeclarationCohabitationFormVM>();

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-family-coexistence-list-content"
        id="panel-person-family-coexistence-list-contentheader"
        expandIcon={<ExpandMore />}
      >
        <Typography>Componenti della famiglia</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FamilyCoexistenceList
          disabled={disabled}
          values={{ identifierAnpr: formContext.values.idFamilyAnpr }}
          generality={{}}
          onChange={noop}
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionFamilyCoexistenceListComponent.displayName = 'Accordion Family Coexistence list component';

const AccordionFamilyCoexistenceList = memo(AccordionFamilyCoexistenceListComponent);

export default AccordionFamilyCoexistenceList;
